import React, {Component} from 'react';
import './index.css'

class BsyRadioItem extends Component {
    constructor(props) {
        super(props);
        this.state = {...this.props}
    }
    radioClick = () => {
        const {value} = this.state
        this.setState({value:!value})
    }
    componentDidMount() {
        this.props.getValue && this.props.getValue(this)
    }
    getValue = () =>{
        const {value} = this.state
        return value
    }
    render() {
        const {text, value} = this.state
        return (
            <div onClick={this.radioClick} className={"BsyRadioItem " + (value ? "select" : "")}>
                <i className={value ? "icon-bsy-check3" : "icon-bsy-gou"}/>
                <span>{React.language(text)}</span>
            </div>
        );
    }
}

export default BsyRadioItem;